import useBaseAPI from './useBaseAPI';

const useRoleAPI = () => {
  const { client, isLoading } = useBaseAPI();

  const getRoles = async () => {
    try {
      const response = await client('get', '/role/');
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const getRole = async (roleId) => {
    try {
      const response = await client('get', `/role/${roleId}`);
      return response?.data;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const addRole = async (payload) => {
    try {
      const response = await client('post', '/role', payload);
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const updateRole = async (roleId, payload) => {
    try {
      const response = await client('post', `/role/${roleId}`, payload);
      return response;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  const deleteRole = async (roleId) => {
    try {
      const response = await client('delete', `/role/${roleId}`);
      return response?.success;
    } catch (error) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  };

  return {
    isLoading,
    getRoles,
    getRole,
    addRole,
    deleteRole,
    updateRole,
  };
};

export default useRoleAPI;
